import Fuse from 'fuse.js';
import { createSelector } from 'reselect';

import { getBodyData, getWidgetsData } from 'store/selectors';
import { removeArrayDuplicates } from 'utils/remove-duplicates';

const getBodyBlocks = (state) => getBodyData(state).blocks || {};
const getBodyOfficesMapBlock = (state) => getBodyBlocks(state).officesMap || {};
export const getOfficesMapHeading = (state) => getBodyOfficesMapBlock(state).headline || '';
export const getOfficesMapHeadlineTagName = (state) =>
  getBodyOfficesMapBlock(state).headlineTagName || '';

export const getOfficesMapWidgetData = (state) => getWidgetsData(state).OfficesMap || {};
export const getOfficesMapSearchQuery = (state) => getOfficesMapWidgetData(state).searchQuery || '';

export const getOfficesMapPointsListWithDuplicates = (state) =>
  getOfficesMapWidgetData(state).points || [];
export const getIsOfficesMapPointsFetched = (state) =>
  getOfficesMapWidgetData(state).isPointsFetched || false;

/**
 * TODO: remove this selector from chain once we move to GraphQL
 */
export const getOfficesMapPointsListRaw = createSelector(
  getOfficesMapPointsListWithDuplicates,
  (list) => removeArrayDuplicates(list, (a, b) => a.code === b.code),
);

/** to make fuse work better, we trim query string */
export const getOfficesMapSearchQueryTrimmed = (state) =>
  getOfficesMapSearchQuery(state).replace(/^\s*(.*?)\s*$/, '$1');

const getOfficesMapPointsListFused = createSelector(
  getOfficesMapPointsListRaw,
  (list) =>
    new Fuse(list, {
      includeScore: true,
      shouldSort: true,
      threshold: 0.4,
      location: 0,
      tokenize: false,
      distance: 300,
      maxPatternLength: 32,
      minMatchCharLength: 2,
      keys: ['address', 'subway.name'],
    }),
);

/**
 * Using Fuse, selector finds the best matches, returns empty list when query is empty
 */
export const getOfficesMapPoints = createSelector(
  getOfficesMapPointsListFused,
  getOfficesMapPointsListRaw,
  getOfficesMapSearchQueryTrimmed,
  (listFused, listRaw, query) => {
    if (query) {
      const list = listFused.search(query);
      const bestScore = list.reduce((minScore, item) => Math.min(item.score, minScore), 1);
      return list
        .filter(({ score }) => score <= bestScore * 2) // only take results that are 3x worse than original;
        .map(({ item }) => item);
    }
    return listRaw;
  },
);
